<template>
  <a-modal
    title="提成明细"
    :centered="true"
    :destroyOnClose="true"
    :bodyStyle="{
      height: 'auto',
      padding: '18px'
    }"
    :footer="null"
    width="1012px"
    v-model:visible="visible"
  >
    <a-spin :spinning="loading">
      <searchOrder @searchList="searchList" @handleExport="handleExport" />
      <div class="user-info">
        <span>ERP编号：{{ userInfo.erpId }}</span>
        <span>姓名：{{ userInfo.manageName }}</span>
      </div>
      <a-table
        class="tableContainer"
        :columns="PurchasedColumns"
        :transformCellText="({ text }) => text ?? '--'"
        :pagination="false"
        :data-source="TableData"
        :rowKey="(record, index) => index"
        :scroll="{ x: '100%', y: 'calc(100vh - 330px)' }"
      >
        <template #handle="{ record }">
          <text class="link" @click="viewWorkOrderDetails(record)">详情</text>
        </template>
      </a-table>
      <a-row type="flex" justify="end" style="margin: 20px 20px 0 0">
        <a-col>
          <a-pagination
            v-if="Total"
            show-size-changer
            show-quick-jumper
            v-model:current="current"
            v-model:pageSize="pageSize"
            :total="Total"
            @change="onChangePage"
            @showSizeChange="onChangePage"
            :show-total="Total => `共${Total}条`"
          />
        </a-col>
      </a-row>
    </a-spin>
    <PatientInfoDetails
      :showAllDialog="showAllDialog"
      :currentInfo="currentInfo"
      @handleCancel="handleCancel"
    />
  </a-modal>
</template>

<script setup>
import { ref, defineExpose, defineProps, reactive } from 'vue'
import PatientInfoDetails from '@/components/PatientInfoDetails'
import useTableTools from '@/views/hooks/useTableTools'
import searchOrder from './searchOrder.vue'
import { PurchasedColumns } from './config'
import { salesBonusDetail } from '@/api/DataCenter'

const { Total, current, pageSize, TableData, normalizeExport } = useTableTools()
const props = defineProps({
  query: {
    type: Object,
    default: () => {}
  }
})
const visible = ref(false)
const userInfo = reactive({
  manageName: '',
  erpId: ''
})
const filterQuery = {
  workOrderId: null,
  serialNumber: null
}
const loading = ref(false)
const initdetail = record => {
  const { manageName, erpId } = record || {}
  userInfo.erpId = erpId
  userInfo.manageName = manageName
  filterQuery.workOrderId = null
  filterQuery.serialNumber = null
  current.value = 1
  TableData.value = []
  listQuery()
}
const searchList = query => {
  const { workOrderId, serialNumber } = query
  filterQuery.workOrderId = workOrderId
  filterQuery.serialNumber = serialNumber
  current.value = 1
  pageSize.value = 10
  listQuery()
}
const handleExport = async query => {
  const { workOrderId, serialNumber } = query
  filterQuery.workOrderId = workOrderId
  filterQuery.serialNumber = serialNumber
  const params = handleQuery()
  loading.value = true
  await normalizeExport(
    '/health-doctor-assistant/doctor-assistant/bonus/detail/excel',
    { ...params },
    '提成明细',
    'post'
  )
  loading.value = false
}
// 接口请求之前的参数处理
const handleQuery = () => {
  const { query } = props
  const params = {
    ...query,
    ...filterQuery,
    pageNo: current.value,
    pageSize: pageSize.value,
    erpId: userInfo.erpId,
    statType: 1 //时间类型（1-日 2-周 3-月）
  }
  delete params.manageName
  return params
}
const listQuery = () => {
  loading.value = true
  const params = handleQuery()
  loading.value = false
  salesBonusDetail(params)
    .then(res => {
      const { list = [], totalCount } = res
      TableData.value = list
      Total.value = totalCount
    })
    .catch(() => {
      TableData.value = []
      Total.value = 0
    })
    .finally(() => {
      loading.value = false
    })
}
// 改变当前页
const onChangePage = (page, size) => {
  current.value = page
  pageSize.value = size
  listQuery()
}
// 查看工单详情
const showAllDialog = ref(false)
const currentInfo = ref({})
const viewWorkOrderDetails = record => {
  showAllDialog.value = true
  currentInfo.value = record
}
const handleCancel = () => {
  showAllDialog.value = false
  currentInfo.value = {}
}

defineExpose({
  visible,
  initdetail
})
</script>
<style lang="scss" scoped>
.user-info {
  margin-bottom: 20px;
  font-size: 14px;
  span {
    padding-right: 20px;
  }
}
.link {
  cursor: pointer;
  color: #1890ff;
}

.pre {
  color: #333333;
  .pointer {
    cursor: pointer;
  }
}

.beRemindedUser {
  position: relative;
  display: flex;

  .gaoClass {
    position: absolute;
    left: -16px;
    width: 4px;
    height: 22px;
    background: #f84f4f;
  }
}

.lgFlg {
  background: rgba(158, 158, 158, 0.3);
  color: #333333;
  // color: #666666;
  // border: 1px solid rgba(102, 102, 102, 0.6);
  text-align: center;
  font-size: 8px;
  border-radius: 4px;
  width: 30px;
  height: 20px;
  min-width: 30px;
  min-height: 20px;
  margin-right: 2px;
}

.flg {
  position: relative;
  text-align: center;
  font-size: 8px;
  border-radius: 4px;
  width: 30px;
  height: 20px;
  min-width: 30px;
  min-height: 20px;
  margin-right: 2px;
}

.userFlg {
  margin-right: 4px;
}
</style>
